export type EraserSettings = {
  /** Радиус попадания в единицах доски. */
  radius: number;
};

const STORAGE_KEY = "wb-eraser-settings";

/**
 * Размеры ластика. Радиус — это «подушка» вокруг указателя: объект стирается,
 * если попал в круг такого радиуса. Раньше радиус был один и жёстко зашит (12),
 * и на тонких линиях ластик цеплял соседние — отсюда жалоба «огромный».
 */
export const ERASER_RADIUS_PRESETS = [
  { radius: 4, label: "S", title: "Мелкий — точно по линии" },
  { radius: 10, label: "M", title: "Средний" },
  { radius: 20, label: "L", title: "Крупный" },
  { radius: 36, label: "XL", title: "Очень крупный — стирает размашисто" },
] as const;

const DEFAULT_SETTINGS: EraserSettings = { radius: 4 };

/** Радиус по умолчанию и в старых местах, где настройка не читается. */
export const ERASER_RADIUS = DEFAULT_SETTINGS.radius;

function loadSettings(): EraserSettings {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_SETTINGS };
    const parsed = JSON.parse(raw) as Partial<EraserSettings>;
    const radius = parsed.radius;
    if (typeof radius === "number" && Number.isFinite(radius) && radius > 0 && radius <= 200) {
      return { radius };
    }
    return { ...DEFAULT_SETTINGS };
  } catch {
    return { ...DEFAULT_SETTINGS };
  }
}

function persistSettings(next: EraserSettings): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    /* ignore quota / private mode */
  }
}

let settings: EraserSettings = loadSettings();

export function getEraserSettings(): EraserSettings {
  // useSyncExternalStore: ссылка стабильна, пока настройки не менялись.
  return settings;
}

export function setEraserSettings(partial: Partial<EraserSettings>): void {
  settings = { ...settings, ...partial };
  persistSettings(settings);
  window.dispatchEvent(new Event("wb-eraser-settings"));
}

export function subscribeEraserSettings(onChange: () => void): () => void {
  const handler = () => onChange();
  window.addEventListener("wb-eraser-settings", handler);
  return () => window.removeEventListener("wb-eraser-settings", handler);
}
